module.exports = {"name":"dt-191015-everest-horses"}


//////////////////
// WEBPACK FOOTER
// ./src/content/project.json
// module id = peJn
// module chunks = 0